/* Cart rows can move when BOGO removes a gift. Address the item, not its position. */
(function () {
  'use strict';
  var fetchCart = window.fetch;
  var activeCartItems = null;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (init && typeof init.body === 'string' && /\/cart\/change(?:\.js)?(?:\?|$)/.test(url || '')) {
      try {
        var body = JSON.parse(init.body);
        if (body.line != null && !body.id) {
          var index = Number(body.line);
          var row = activeCartItems
            ? activeCartItems.querySelector('#CartDrawer-Item-' + index + ', #CartItem-' + index)
            : document.getElementById('CartDrawer-Item-' + index) || document.getElementById('CartItem-' + index);
          var key = row && row.getAttribute('data-cart-line-key');
          if (!key && row) {
            var removeLink = row.querySelector('cart-remove-button a[href]');
            if (removeLink) key = new URL(removeLink.href, window.location.origin).searchParams.get('id');
          }
          if (key) {
            body.id = key;
            delete body.line;
            init = Object.assign({}, init, { body: JSON.stringify(body) });
          }
        }
      } catch (error) { /* Leave non-JSON theme requests unchanged. */ }
    }
    return fetchCart.call(this, input, init);
  };

  customElements.whenDefined('cart-items').then(function () {
    var proto = customElements.get('cart-items').prototype;
    var onChange = proto.onChange;
    var updateQuantity = proto.updateQuantity;
    proto.onChange = function (event) {
      var input = event.target;
      // Variant selectors and detached debounced inputs are not quantity changes.
      if (!input || !input.isConnected || !input.matches('.quantity__input[data-index]')) return;
      return onChange.call(this, event);
    };
    proto.updateQuantity = function (line, quantity, name) {
      if (this.sssQuantityPending || !Number.isInteger(Number(line)) || Number(line) < 1) return Promise.resolve();
      this.sssQuantityPending = true;
      var self = this;
      return Promise.resolve().then(function () {
        activeCartItems = self;
        try { return updateQuantity.call(self, line, quantity, name); }
        finally { activeCartItems = null; }
      }).finally(function () { self.sssQuantityPending = false; });
    };
  });
})();
